import {Model, INumber, IDate} from '@ab/components';

class Percent extends Model {
    static fields = {
        date: {
            fieldConstructor: IDate,
        },
        amount_body: {
            fieldConstructor: INumber,
            value: 0,
        },
        amount_day_debit: {
            fieldConstructor: INumber,
            value: 0,
        },
        amount_day_credit: {
            fieldConstructor: INumber,
            value: 0,
        },
        amount_interest: {
            fieldConstructor: INumber,
            value: 0,
        },
        amount_interest_cumulative: {
            fieldConstructor: INumber,
            value: 0,
        },
    };
}

export default Percent;
